/* unplugin-vue-components disabled */import { render } from "./DiagramChapterViewer.vue?vue&type=template&id=37035ef7&scoped=true&ts=true"
import script from "./DiagramChapterViewer.vue?vue&type=script&lang=ts"
export * from "./DiagramChapterViewer.vue?vue&type=script&lang=ts"

import "./DiagramChapterViewer.vue?vue&type=style&index=0&id=37035ef7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37035ef7"]])

export default __exports__